import { GROUPS_PERMISSIONS,USERS_PERMISSIONS } from "../lib/constants/actions";
export const groupsPermission = (state = {}, action) => {
    switch (action.type) {
        case GROUPS_PERMISSIONS.GET_PERMISSIONS_SUCCESS:
            return { ...state, groupPermissions: action.payload }
        case GROUPS_PERMISSIONS.UPDATE_PERMISSIONS_SUCCESS:
            return { ...state, groupPermAdded: action.payload }
        case USERS_PERMISSIONS.GET_USER_PERMISSIONS_SUCCESS:
            return { ...state, userPermissions: action.payload }
        case USERS_PERMISSIONS.UPDATE_USER_PERMISSIONS_SUCCESS:
            return { ...state, userPermAdded: action.payload }
        default:
            return state;
    }
};




